import React from 'react';

const PeriodStartEvent = ({ event }) => {
    const periodNumber = event.periodDescriptor?.number || 'N/A';

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Period Start:</span>
            <span className="text-sm text-gray-900">{periodNumber}</span>
        </div>
    );
};

export default PeriodStartEvent;
